<template>
  <div
    class="prompt-container"
    :class="{'absolute': isFocus}"
  >
    <div class="prompt"></div>
    <div class="coupon-container">
      <div class="coupon-title">
        <span v-if="useCouponInput">优惠码</span>
        <span v-else>使用优惠券</span>
        <i
          class="close-icon"
          @click="close"
        />
      </div>
      <div
        class="coupon-content"
        v-if="showType === 'list'"
      >
        <div
          class="coupon-list-container"
          v-if="myCoupon.usableList.length"
        >
          <p class="coupon-list-title">
            可用优惠券（{{ myCoupon.usableList.length }}）
          </p>
          <ul class="coupon-list">
            <li
              class="coupon-item"
              v-for="(item, index) in myCoupon.usableList"
              :key="index"
              @click="selectCoupon(item)"
            >
              <div class="coupon-icon-content">
                {{ item.isReceived }}
                <i
                  class="coupon-icon"
                  :class="item.couponMode"
                />
              </div>
              <div class="coupon-info">
                <p class="coupon-name ellipsis">
                  {{ item.couponName }}
                </p>
                <p class="coupon-desc ellipsis">
                  <span><span
                    class="coupon-symbol"
                    v-if="item.couponMode != 'Discount'"
                  >￥</span><span
                    class="coupon-discount"
                    v-if="item.couponMode == 'Random'"
                  >{{ item.amountMin | cut }}~{{ item.amountMax | cut }}</span><span
                    class="coupon-discount"
                    v-else
                  >{{ item.amountMax | cut }}</span><span
                    class="coupon-symbol"
                    v-if="item.couponMode == 'Discount'"
                  >折</span></span><span class="coupon-text">满￥{{ item.limitMin }}可用</span>
                </p>
              </div>
              <i
                class="coupon-receive-btn"
                :class="[item.isSelected ? 'active' : '']"
              />
            </li>
          </ul>
        </div>
        <div
          class="coupon-list-container"
          v-if="myCoupon.unusableList.length"
        >
          <p class="coupon-list-title">
            不可用优惠券（{{ myCoupon.unusableList.length }}）
          </p>
          <ul class="coupon-list not">
            <li
              class="coupon-item no-padding-right"
              v-for="(item, index) in myCoupon.unusableList"
              :key="index"
            >
              <div class="coupon-icon-content">
                <i
                  class="coupon-icon"
                  :class="item.couponMode"
                />
              </div>
              <div class="coupon-info">
                <p class="coupon-name ellipsis">
                  {{ item.couponName }}
                </p>
                <p class="coupon-desc ellipsis">
                  <span><span
                    class="coupon-symbol"
                    v-if="item.couponMode != 'Discount'"
                  >￥</span><span
                    class="coupon-discount"
                    v-if="item.couponMode == 'Random'"
                  >{{ item.amountMin | cut }}~{{ item.amountMax | cut }}</span><span
                    class="coupon-discount"
                    v-else
                  >{{ item.amountMax | cut }}</span><span
                    class="coupon-symbol"
                    v-if="item.couponMode == 'Discount'"
                  >折</span></span><span class="coupon-text">满￥{{ item.limitMin }}可用</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="toggle"
        v-if="showType === 'list'"
        @click="useCouponInput = true"
      >
        使用优惠码
      </div>
      <div
        class="coupon-empty"
        v-if="!myCoupon.count && !useCouponInput"
      >
        <div class="empty"></div>
        <div class="desc">
          暂无可用优惠券
        </div>
        <div
          class="toggle"
          @click="useCouponInput = true"
        >
          使用优惠码
        </div>
      </div>
      <div
        class="coupon-input-content"
        v-if="showType === 'input' && useCouponInput"
      >
        <div class="coupon-input">
          <input
            type="text"
            class="roll-input"
            maxlength="8"
            placeholder="请输入优惠券码"
            @input="couponInput"
            v-model="couponCode"
            @focus="focus"
            @blur="blur"
            @keyup.enter="validateCouponCode"
          >
        </div>
        <p
          class="error-tip"
          v-show="errortxt"
        >
          {{ errortxt }}
        </p>
        <div
          class="btn-row clearfix"
          :class="{error: errortxt}"
        >
          <v-button
            :disabled="disabled"
            @click="validateCouponCode"
          >
            立即使用
          </v-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {isIOS} from '../utils/'
  import {mapGetters, mapState} from 'vuex'
  import vButton from './Button'

  export default {
    name: 'Coupon',
    computed: {
      ...mapGetters({
        client: 'client',
        user: 'user',
        product: 'skuDetail',
        myCoupon: 'couponList',
        priceInfo: 'priceInfo'
      }),
      ...mapState({
        amount: state => state.product.amount
      }),
      // 优惠显示类型
      showType() {
        if (this.useCouponInput) {
          return 'input'
        } else if (this.myCoupon.count > 0) {
          return 'list'
        } else {
          return 'input'
        }
      }
    },
    data() {
      return {
        useCouponInput: false, // 是否使用优惠码
        couponCode: '', // 优惠码
        disabled: true, // 确认使用优惠码按钮可点击状态
        errortxt: '', // 优惠码提示文字
        isFocus: false // 优惠券码输入框是否获焦
      }
    },
    methods: {
      close() {
        this.$emit('close')
      },
      focus() {
        // 奇葩的修复 IOS fixed input排版导致input输入框被软键盘覆盖或不显示问题
        this.$nextTick(() => {
          isIOS() && (this.isFocus = true)
        })
      },
      blur() {
        this.$nextTick(() => {
          isIOS() && (this.isFocus = false)
          window.scrollTo(0, scroll)
        })
      },
      couponInput() {
        this.errortxt = ''
        this.couponCode = this.couponCode.replace(/[^A-Z]/g, '')
        if (this.couponCode.length === 8) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      },
      // 验证优惠码
      validateCouponCode() {
        if (this.disabled) return
        this.disabled = true
        this.$store.dispatch('validateCouponCode', {couponCode: this.couponCode})
          .then(() => {
            this.disabled = false
            this.close()
          })
          .catch(e => {
            this.disabled = false
            if (e.resultDesc || e.errorMessage) {
              this.errortxt = e.resultDesc || e.errorMessage
            } else {
              this.errortxt = '该优惠码不可用'
            }
          })
      },
      // 选择优惠券
      selectCoupon(coupon) {
        if (Number(coupon.limitMin) > (this.amount * Number(this.product.sellingPrice))) {
          this.$toast('此优惠券不满足使用条件，请选择其他优惠券')
          return false
        }
        let selectedCoupon = {} // 优惠券信息
        if (coupon.isSelected) { // 已选中则取消选择
          coupon.isSelected = false
        } else { // 首先全部取消，再选中当前
          this.myCoupon.usableList.forEach(coupon => {
            coupon.isSelected = false
          })
          coupon.isSelected = true
          selectedCoupon = coupon
        }
        this.updateSelecteCoupon(selectedCoupon)
        this.close()
      },
      updateSelecteCoupon(couponInfo) {
        setTimeout(() => {
          this.$store.dispatch('updateCouponInfo', {couponInfo})
        }, 400)
      }
    },
    components: {
      vButton
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/common.scss";

  .prompt-container {
    overflow: hidden;
  }

  .coupon-container {
    width: 100%;
    background: #f1f1f1;
    position: fixed;
    bottom: 0;
    left: 0;
    max-height: 1202px;
    z-index: 1000;
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .coupon-title {
      width: 100%;
      height: 120px;
      font-size: 48px;
      color: #000000;
      position: relative;
      background-color: #fff;
      text-align: center;
      line-height: 120px;
      .close-icon {
        width: 39px;
        height: 39px;
        display: inline-block;
        position: absolute;
        right: 55px;
        top: 50%;
        margin-top: -20px;
        background: url("../assets/image/close2.png") no-repeat;
        background-size: contain;
      }
    }
    .coupon-content {
      padding: 47px;
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      min-height: 300px;
      max-height: 900px;
      .coupon-list-title {
        font-size: 36px;
        color: #999;
        padding-bottom: 20px;
      }
      .coupon-list-container {
        margin-bottom: 47px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .coupon-list {
        .coupon-item {
          position: relative;
          height: 182px;
          padding: 0 120px 0 223px;
          background-color: #fff;
          margin-bottom: 20px;
          border-radius: 8px;
          &.no-padding-right {
            padding-right: 0;
          }
          &.received {
            background-image: url("../assets/image/already.png");
            background-repeat: no-repeat;
            background-position: 98% -101px;
            background-size: 293px;
          }
          .coupon-icon-content {
            position: absolute;
            left: 0px;
            top: 0px;
            width: 210px;
            height: 100%;
            @extend %flex-center-center;
            border-right: 1PX dashed #f1f1f1; /*no*/
            .coupon-icon {
              background-repeat: no-repeat;
              display: inline-block;
              background-size: contain;
              width: 120px;
              &.Discount {
                height: 83px;
                background-image: url("../assets/image/discount.png");
              }
              &.Random {
                height: 90px;
                background-image: url("../assets/image/random.png");
              }
              &.Cash {
                height: 104px;
                background-image: url("../assets/image/cash.png");
              }
            }
          }
          .coupon-receive-btn {
            width: 60px;
            height: 60px;
            position: absolute;
            top: 50%;
            right: 46px;
            margin-top: -30px;
            background: url(../assets/image/radio.png) no-repeat;
            background-size: contain;
            &.active {
              background-image: url(../assets/image/radio-active-yellow.png);
            }
          }
          .coupon-info {
            padding: 26px 0 26px 46px;
            &:before,
            &:after {
              content: "";
              display: block;
              position: absolute;
              border-radius: 50%;
              background-color: #f1f1f1;
              z-index: 10;
              width: 24px;
              height: 24px;
              left: 198px;
            }
            &:before {
              top: -12px;
            }
            &:after {
              bottom: -12px;
            }
            .coupon-name {
              font-size: 42px;
              color: #000000;
              letter-spacing: 0px;
              width: 100%;
            }
            .coupon-desc {
              font-size: 33px;
              color: #666666;
              .coupon-symbol,
              .coupon-discount {
                color: #ff0000;
              }
              .coupon-symbol {
                font-size: 36px;
              }
              .coupon-discount {
                font-size: 60px;
              }
              .coupon-text {
                padding-left: 35px;
              }
            }
          }
        }
        &.not {
          .coupon-icon {
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
            filter: gray;
          }
        }
      }
    }
    .coupon-empty {
      padding-top: 68px;
      .empty {
        width: 296px;
        height: 320px;
        background-image: url('../assets/image/no-data.png');
        background-size: 100%;
        background-repeat: no-repeat;
        margin: 84px auto 47px;
        display: block;
      }
      .desc {
        color: #999999;
        font-size: 36px;
        text-align: center;
        margin-bottom: 50px;
      }
    }
    .toggle {
      font-size: 36px;
      text-align: center;
      color: #fbb114;
      padding: 30px 0 40px;
      padding-bottom: calc(30px + constant(safe-area-inset-bottom));
      padding-bottom: calc(30px + env(safe-area-inset-bottom));
      text-decoration: underline
    }
    .coupon-input-content {
      padding: 60px 0;
      background-color: #fff;
      padding-bottom: calc(60px + constant(safe-area-inset-bottom));
      padding-bottom: calc(60px + env(safe-area-inset-bottom));
      .coupon-input {
        width: 720px;
        margin: 0 auto 50px;
        border-bottom: solid 1PX #bbb; /*no*/
      }
      .roll-input {
        width: 100%;
        height: 108px;
        font-size: 60px;
        text-align: center;
        border: none;
        &::-webkit-input-placeholder {
          font-size: 50px;
        }
        &::-moz-placeholder {
          font-size: 50px;
        }
        &:-ms-input-placeholder {
          font-size: 50px;
        }
      }
    }
    .error-tip {
      color: #ff5252;
      font-size: 39px;
      text-align: center;
      padding-bottom: 20px;
    }

  }
</style>
